/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 09:49:55 
 * @Last Modified by:   jingyu.yang 
 * @Last Modified time: 2021-12-17 09:49:55 
 */
import { post as Post, get as Get, getJson as GetJson, deleteMethod as DeleteMethod, put as Put } from '@/api/http';
import store from '@/store'
const getParam = (...args) => {
  const [url, param, headers, ...others] = args[0]
  return [url, param, Object.assign({}, headers || {}, { token: store.getters.sid, token_type: "sid" }), ...others]
}
export function post() {
  return Post(...getParam(arguments))
}
export function get() {
  return Get(...getParam(arguments))
}
export function getJson() {
  return GetJson(...getParam(arguments))
}
export function deleteMethod() {
  return DeleteMethod(...getParam(arguments))
}
export function put() {
  return Put(...getParam(arguments))
}
